import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ArgumentNullError, ConnectionMessage } from "../common/Exports";
var PathHeaderName = "path";
var ContentTypeHeaderName = "content-type";
var RequestIdHeaderName = "x-requestid";
var RequestTimestampHeaderName = "x-timestamp";
export var SpeechConnectionMessage = /*#__PURE__*/function (_ConnectionMessage) {
  _inherits(SpeechConnectionMessage, _ConnectionMessage);

  var _super = _createSuper(SpeechConnectionMessage);

  function SpeechConnectionMessage(messageType, path, requestId, contentType, body, additionalHeaders, id) {
    var _this;

    _classCallCheck(this, SpeechConnectionMessage);

    if (!path) {
      throw new ArgumentNullError("path");
    }

    if (!requestId) {
      throw new ArgumentNullError("requestId");
    }

    var headers = {};
    headers[PathHeaderName] = path;
    headers[RequestIdHeaderName] = requestId;
    headers[RequestTimestampHeaderName] = new Date().toISOString();

    if (contentType) {
      headers[ContentTypeHeaderName] = contentType;
    }

    if (additionalHeaders) {
      for (var headerName in additionalHeaders) {
        if (headerName) {
          headers[headerName] = additionalHeaders[headerName];
        }
      }
    }

    if (id) {
      _this = _super.call(this, messageType, body, headers, id);
    } else {
      _this = _super.call(this, messageType, body, headers);
    }

    _this.privPath = path;
    _this.privRequestId = requestId;
    _this.privContentType = contentType;
    _this.privAdditionalHeaders = additionalHeaders;
    return _possibleConstructorReturn(_this);
  }

  _createClass(SpeechConnectionMessage, [{
    key: "path",
    get: function get() {
      return this.privPath;
    }
  }, {
    key: "requestId",
    get: function get() {
      return this.privRequestId;
    }
  }, {
    key: "contentType",
    get: function get() {
      return this.privContentType;
    }
  }, {
    key: "additionalHeaders",
    get: function get() {
      return this.privAdditionalHeaders;
    }
  }]);

  return SpeechConnectionMessage;
}(ConnectionMessage);

SpeechConnectionMessage.fromConnectionMessage = function (message) {
  var path = null;
  var requestId = null;
  var contentType = null;
  var requestTimestamp = null;
  var additionalHeaders = {};

  if (message.headers) {
    for (var headerName in message.headers) {
      if (headerName) {
        if (headerName.toLowerCase() === PathHeaderName.toLowerCase()) {
          path = message.headers[headerName];
        } else if (headerName.toLowerCase() === RequestIdHeaderName.toLowerCase()) {
          requestId = message.headers[headerName];
        } else if (headerName.toLowerCase() === RequestTimestampHeaderName.toLowerCase()) {
          requestTimestamp = message.headers[headerName];
        } else if (headerName.toLowerCase() === ContentTypeHeaderName.toLowerCase()) {
          contentType = message.headers[headerName];
        } else {
          additionalHeaders[headerName] = message.headers[headerName];
        }
      }
    }
  }

  return new SpeechConnectionMessage(message.messageType, path, requestId, contentType, message.body, additionalHeaders, message.id);
};